import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [user, setUser] = useState({});

  const navigate = useNavigate();
  const checkSession = async () => {
    const user = await localStorage.getItem("USER_IUMV");
    setUser(JSON.parse(user));
    if (!user) {
      navigate("/Login");
      return;
    }
  };

  useEffect(() => {
    checkSession();
  }, []);

  return (
    <div
      className="hidden lg:flex items-center justify-between px-8"
      style={{
        backgroundColor: '#991b1b',
        minHeight: '58px',
        borderBottom: '1px solid #7f1d1d',
      }}
    >
      {/* Logo */}
      <div className="flex items-center flex-shrink-0">
        <img
          src="https://intranet.iumv.edu.mx/logo_iumv.png"
          alt="IUMV"
          style={{ maxHeight: '40px' }}
          onError={e => { e.target.style.display = 'none'; }}
        />
      </div>

      {/* User info — right side */}
      <div className="flex items-center gap-3">
        {user.name && (
          <div style={{ textAlign: 'right' }}>
            <p style={{ fontSize: '0.82rem', fontWeight: 700, color: '#f9fafb', lineHeight: 1.2 }}>{user.name}</p>
            {user.curp && (
              <p style={{ fontSize: '0.68rem', color: '#6b7280', fontFamily: 'monospace', marginTop: '1px' }}>{user.curp}</p>
            )}
          </div>
        )}

        {/* Divider */}
        {user.name && <div style={{ width: '1px', height: '28px', backgroundColor: 'rgba(255,255,255,0.25)' }} />}

        {user.university_name && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px', backgroundColor: 'rgba(0,0,0,0.2)', padding: '4px 10px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.15)' }}>
            <i className="fa-solid fa-building-columns" style={{ fontSize: '10px', color: '#dc2626' }}></i>
            <span style={{ fontSize: '0.72rem', color: '#d1d5db', fontWeight: 500 }}>{user.university_name}</span>
          </div>
        )}

        {user.type === "staff" ? (
          user.description_position && (
            <div style={{ backgroundColor: 'rgba(0,0,0,0.2)', padding: '4px 10px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.15)' }}>
              <span style={{ fontSize: '0.72rem', color: '#d1d5db', fontWeight: 500 }}>{user.description_position}</span>
            </div>
          )
        ) : (
          <Fragment>
            {user.career_name && (
              <div style={{ backgroundColor: 'rgba(0,0,0,0.2)', padding: '4px 10px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.15)' }}>
                <span style={{ fontSize: '0.72rem', color: '#d1d5db', fontWeight: 500 }}>{user.career_name}</span>
              </div>
            )}
            {(user.start_date || user.end_date) && (
              <div style={{ fontSize: '0.68rem', color: '#6b7280' }}>
                {user.start_date && <span>{user.start_date}</span>}
                {user.start_date && user.end_date && <span style={{ margin: '0 4px' }}>→</span>}
                {user.end_date && <span>{user.end_date}</span>}
              </div>
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default Header;
